export const load = () => ({
	title: 'Historic Preservation: Indow Inserts in Frank Lloyd Wright Homes',
	description:
		"See how Indow inserts provide a nondestructive, invisible solution for preserving Frank Lloyd Wright's single pane windows while boosting energy efficiency, eliminating drafts, and reducing noise.",
	showTitle: true,
});
